import styled from 'styled-components';
import { string, oneOf, shape } from 'prop-types';
import { getBodyCopy } from '@bbc/gel-foundations/typography';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { C_SHADOW } from '@bbc/psammead-styles/colours';
import { GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
var BulletedList = /*#__PURE__*/styled.ul.attrs(function () {
  return {
    role: 'list'
  };
}).withConfig({
  displayName: "BulletedList",
  componentId: "sc-13z0d8v-0"
})(["", ";", ";margin-top:0;list-style-type:none;& > li{position:relative;}& > li::before{top:0.5rem;content:' ';position:absolute;border-width:1rem;border:0.1875rem solid ", ";border-radius:50%;", "}"], function (_ref) {
  var script = _ref.script;
  return script && getBodyCopy(script);
}, function (_ref2) {
  var service = _ref2.service;
  return getSansRegular(service);
}, C_SHADOW, function (_ref3) {
  var dir = _ref3.dir;
  return dir === 'rtl' ? 'right: -1rem;' : 'left: -1rem;';
});
export var BulletedListItem = /*#__PURE__*/styled.li.attrs(function () {
  return {
    role: 'listitem'
  };
}).withConfig({
  displayName: "BulletedListItem",
  componentId: "sc-13z0d8v-1"
})(["margin-bottom:", ";"], GEL_SPACING_DBL);
BulletedList.propTypes = {
  script: shape(scriptPropType).isRequired,
  dir: oneOf(['ltr', 'rtl']),
  service: string.isRequired
};
BulletedList.defaultProps = {
  dir: 'ltr'
};
export default BulletedList;